import Crypto from 'crypto-js';

/**
 * MD5
 * @param {*} data
 * @returns
 */
const MD5 = data => {
  let result = Crypto.MD5(data);
  return result.toString();
};

export { MD5 };
